import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-up-right', 'ChevronUpRight', [["path",{"d":"M8 8h8v8"}]]);